<template>
  <div class="batchAmountRemission">
    <QS-scroller-box>
      <QS-h3-title title="批量金额减免">
        <template slot="content">
            <el-tooltip class="item" content="车辆入库后，由系统创建的应收单操作减免，车辆交接时间将不可修改" placement="right"><i class="el-icon-question"></i></el-tooltip>
          </template>
      </QS-h3-title>
      <div class="selectFile">
        <div class="selectFile_button">
          <span>选择文件：</span>
          <el-upload
            class="upload-demo"
            action=""
            :http-request="uploadRequest"
            :autoUpload="true"
            :file-list="fileList"
            :show-file-list="false"
          >
            <el-button type="primary" size="small">选择</el-button>
          </el-upload>
        </div>
        <el-button
          type="text"
          size="small"
          ><a :href="batchAmountRemission">导入模板下载</a></el-button
        >
      </div>
      <QS-common-table
        class="mt16"
        :loading="loadingSearch"
        :pagination="paginationData"
        :data="tableData"
        :columns="m_headData"
        @change="paginationChange"
      ></QS-common-table>
     <!-- 增加输入框 -->
     <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" style="margin-top:20px" :inline="true">
        <el-form-item label="减免说明" prop="remark">
          <el-input :maxlength="500" style="width:300px" :rows="4" type="textarea" resize="none" v-model="formData.remark"></el-input>
        </el-form-item>
        <el-form-item prop="attachment" label="减免凭证">
          <div>
            <UploadCommon
              fileTitle="减免凭证"
              :multiple="true"
              :limit="6"
              :fileList.sync="formData.attachment"
              :sizeType="4"
              listType="text"
              commonUpload
              group="finance"
              code="finance_reduction_agreement_pic"
            />
          </div>

      </el-form-item>
      </el-form>
      <template slot="bottomAction">
        <div class="sumbit-btns">
          <el-button @click="goPageBack" size="small">取消</el-button>
          <el-button
            v-if="!dingTalkShow"
            v-loading.fullscreen.lock="loadingConfirm"
            type="primary"
            size="small"
            :disabled="btnDisabled"
            @click="confirmBtn"
            >确认</el-button
          >
          <el-button
            v-else
            v-loading.fullscreen.lock="loadingConfirm"
            type="primary"
            size="small"
            :disabled="btnDisabled"
            @click="sunbmitDdApprove"
            >提交钉钉审批</el-button
          >
        </div>
      </template>

    </QS-scroller-box>
    <!-- 钉钉审批异常弹窗 -->
    <approve-validate-dialog
            ref="approveValidateDialogRef"
            :dingTalkShow="dingTalkShow"
            :sunbmitFun="confirm"
            :tableData="tableData"
            @reloadClick="getDingTalkBtnStatus"
        />
    <!-- 导入失败-弹窗 -->
    <dialogWrap
      v-model="uploadDialogShow"
      title="导入失败提示"
      :width="'750px'"

      class="spring-frame"
      :before-close="beforeUploadClose"
    >
      <p
        v-for="(item, index) in uploadTableData"
        :key="index"
        style="margin-bottom: 8px"
      >
        {{ item }}
      </p>
    </dialogWrap>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { receivableChangeRelieveImport, receivableChangeRelieveGetImportList, receivableConfirm } from '@/api/financeApi'
import { batchAmountRemission } from '@/config'
import axios from 'axios'
import { getHead } from '@/utils'
import { mapState } from 'vuex'
import mixins from './mixins'
import { getSubmitDingTalkShow } from '@/api/global'
import ApproveValidateDialog from '../components/ApproveValidateDialog'

export default {
  components: {
    ApproveValidateDialog,
  },
  data() {
    return {
      batchAmountRemission,
      loadingSearch: false,
      loadingConfirm: false,
      uploadDialogShow: false, // 导入错误弹窗
      uploadTableData: [], // 导入错误数据
      fileList: [],
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      tableData: [],
      formData: {
        remark: '',
        attachment: [], // 减免凭证
      },
      rules: {
        remark: [
          { required: true, message: '请填写减免说明', trigger: 'blur' },
        ],
        attachment: [{ required: true, message: '减免凭证不能为空', trigger: 'change' }],
      },
      dingTalkShow: false, // 是否开启审批
    }
  },
  computed: {
    ...mapState({
      // eslint-disable-next-line vue/no-unused-properties
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    btnDisabled() {
      return !(this.tableData && this.tableData.length)
    },
  },
  mixins: [mixins],
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    this.getDingTalkBtnStatus()
  },
  methods: {
    // 确认按钮
    confirmBtn() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$refs.approveValidateDialogRef.receivableFilterReceivable()
        }
      })
    },
    // 提交钉钉审批
    sunbmitDdApprove() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          await this.getDingTalkBtnStatus()
          this.$refs.approveValidateDialogRef.sunbmitDdApprove()
        }
      })
    },
    // 查询钉钉审批是否开通
    async getDingTalkBtnStatus() {
      const params = {
        bizType: 12,
      }
      const { data } = await getSubmitDingTalkShow(params)
      this.dingTalkShow = data
    },
    beforeUploadClose() {
      this.uploadTableData = []
      this.uploadDialogShow = false
    },
    // 取消
    goPageBack(status = false) {
      this.$refreshBack(status)
    },
    // 确认
    confirm(receivableIds) {
      if (this.loadingConfirm) return
      this.loadingConfirm = true
      receivableConfirm({
        recordId: this.recordId,
        remark: this.formData.remark,
        // eslint-disable-next-line no-mixed-operators
        approvalAccessModeType: this.dingTalkShow && 2 || '',
        receivableIds, // 正在审核中的数据
        attachment: this.getUoloadCommonFileData(this.formData.attachment) || null,
      }).then((res) => {
        const { code } = res
        if (code === 1) {
          const msg = this.dingTalkShow ? '发起审批成功' : '提交成功！'
          this.$message.success(msg)
          this.goPageBack(true)
        }
      }).finally(() => {
        this.loadingConfirm = false
      })
    },
    // 分页
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.receivableChangeRelieveGetImportList()
    },
    // 查看导入列表
    receivableChangeRelieveGetImportList() {
      receivableChangeRelieveGetImportList({
        ...this.paginationData,
        recordId: this.recordId,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.tableData = data.items || []
          this.paginationData.total = data.totalNum || 0
        }
      })
    },
    /* 自定义上传 */
    uploadRequest({ file }) {
      this.loadingSearch = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'finance')
      formData.append('code', 'finance_reduction_agreement_pic')
      axios({
        url: '/admin/v1/vehicle/fs/standard/upload',
        method: 'POST',
        data: formData,
        headers: {
          ...this.headers,
          ...getHead(this.$store),
        },
      }).then(({ data: { code, data, msg } }) => {
        if (code === 1) {
          try {
            receivableChangeRelieveImport({
              fileAddress: data,
            })
              .then((res) => {
                if (res?.code === 1 && res?.data) {
                  const { msgList, recordId } = res.data
                  if (msgList.length > 0) {
                    this.uploadTableData = res?.data.msgList || []
                    this.uploadDialogShow = true
                  } else {
                    this.recordId = recordId
                    this.paginationChange({
                      pagination: {
                        pageSize: 10,
                        pageNum: 1,
                      },
                    })
                  }
                }
                this.loadingSearch = false
              })
              .catch(() => {
                this.loadingSearch = false
              })
          } catch (error) {
            this.loadingSearch = false
          }
        } else {
          this.$message.error(msg)
          this.fileList = []
        }
        this.loadingSearch = false
      }).catch(() => {
        this.fileList = []
        this.loadingSearch = false
      })
    },
  },
  watch: {
    'formData.attachment': {
      handler() {
        this.$refs.formRef.validateField('attachment')
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.batchAmountRemission {
  .selectFile {
    display: flex;
    align-items: center;

    .selectFile_button{
      display: flex;
      align-items: center;
      margin-right: 20px;
    }
  }
}
</style>
